import * as React from "react";

import { reject } from "../TypingUtils";

import { ICandyApiClient } from "./ICandyApiClient";

const CandyApiClientContext = React.createContext<ICandyApiClient | undefined>(undefined);

export const CandyApiClientProvider = CandyApiClientContext.Provider;

export function useCandyApiClient(): ICandyApiClient {
    return (
        React.useContext(CandyApiClientContext) ??
        reject("ICandyApiClient must be provided with CandyApiClientProvider")
    );
}
